import { LeadSourcesBreakdown } from './LeadSourcesBreakdown'
import { LeadStatsCards } from './LeadStatsCards'

export const LeadSourceContent = () => {
   return (
      <div>
         <LeadStatsCards />
         <LeadSourcesBreakdown />
      </div>
   )
}
